import {
  DocumentTemplateSummary,
  EncounterSchema,
  SchemaDocumentRef,
} from '@/entities/templates';

export type TemplateSpecialtyGroup = {
  schema: EncounterSchema;
  templates: DocumentTemplateSummary[];
};

const getTemplateLookupKey = (
  seriesId?: string | null,
  code?: string,
): string => (seriesId ? `series:${seriesId}` : `code:${code ?? ''}`);

const getSchemaDocumentLookupKey = (document: SchemaDocumentRef): string =>
  document.template_series_id
    ? `series:${document.template_series_id}`
    : `code:${document.code}`;

export const getTemplateSpecialtyGroups = (
  schemas: EncounterSchema[],
  templates: DocumentTemplateSummary[],
): {
  groups: TemplateSpecialtyGroup[];
  ungroupedTemplates: DocumentTemplateSummary[];
} => {
  const groupedKeys = new Set<string>();

  const groups = schemas.map((schema) => {
    const schemaKeys = new Set(
      schema.documents.map((document) => {
        const key = getSchemaDocumentLookupKey(document);
        groupedKeys.add(key);
        return key;
      }),
    );

    return {
      schema,
      templates: templates.filter((template) =>
        schemaKeys.has(getTemplateLookupKey(template.series_id, template.code)),
      ),
    };
  });

  return {
    groups,
    ungroupedTemplates: templates.filter(
      (template) =>
        !groupedKeys.has(
          getTemplateLookupKey(template.series_id, template.code),
        ),
    ),
  };
};

export const getTemplateParentSchema = (
  template: DocumentTemplateSummary,
  groups: TemplateSpecialtyGroup[],
): EncounterSchema | null =>
  groups.find(({ templates }) =>
    templates.some((item) => item.id === template.id),
  )?.schema ?? null;
